(function () {
  const vooPriceElement = document.querySelector('.voo-price');
  const btnPriceElement = document.querySelector('.voo-product-form__btn-price');
  const qtyInput = document.querySelector('.price-per-item__container .quantity__input');
  const vooMainProduct = document.querySelector('.voo-main-product');

  if (vooPriceElement) {
    const regularPriceElement = vooPriceElement.querySelector('.price-item--regular');

    if (regularPriceElement) {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (btnPriceElement) {
            const totalPrice = (parseFloat(mutation.target.textContent.replace(/[^0-9.]/g, '')) * qtyInput.value) / 100;
            btnPriceElement.textContent = `${window.countryCurrency.symbol}${totalPrice.toFixed(2).replace('.', ',')}`;
          }
        });
      });

      const config = { attributes: true, childList: true, subtree: true };
      observer.observe(regularPriceElement, config);
    }

    const priceObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        const untilPriceCaption = vooPriceElement.querySelector('.unit-price.caption .price-item');
        const productFormUnitPrice = document.querySelector('.product-form__unit_price');

        if (untilPriceCaption && productFormUnitPrice) {
          if (untilPriceCaption.textContent.includes('ml')) {
            productFormUnitPrice.innerHTML = untilPriceCaption.innerHTML;
          }
        }
      });
    });

    priceObserver.observe(vooPriceElement, { childList: true, subtree: true });
  }

  if (vooMainProduct) {
    let vooSelectedProducts = [];
    let productInventoryMap = new Map();

    const initializeProductInventory = () => {
      const sortProductItems = document.querySelectorAll('.voo-sort-product-item');
      sortProductItems.forEach((item) => {
        const productIdInput = item.querySelector('.voo-sort-radio');
        productInventoryMap.set(productIdInput.value, { available: item.classList.contains('voo-sort-product-item--disabled') ? false : true, quantity: parseInt(item.dataset.availableQuantity)});
      });
    };

    initializeProductInventory();

    const initProducts = () => {
      const selectedInputs = document.querySelectorAll('.voo-sort-radio[data-product-checked]');

      selectedInputs.forEach((input) => {
        const productId = input.value;
        const product = productInventoryMap.get(productId);

        if (!product) return;

        if (product.available) {
          product.quantity -= 1;
          if (product.quantity <= 0) {
            product.available = false;
            const allProductEntities = document.querySelectorAll(`input[value="${productId}"]:not([data-product-checked])`);
            allProductEntities.forEach((radio) => {
              const parentItem = radio.closest('.voo-sort-product-item');
              if (parentItem) {
                parentItem.classList.add('voo-sort-product-item--disabled');
              }
            });
          }
        } else if (!product.available) {
          input.removeAttribute('data-product-checked');
          input.checked = false;
          const parentItem = input.closest('.voo-sort-product-item');
          if (!parentItem) return;
          parentItem.classList.add('voo-sort-product-item--disabled');

          let nextItem = parentItem.nextElementSibling;

          while (nextItem) {
            const nextInput = nextItem.querySelector('.voo-sort-radio');
            if (!nextInput) {
              nextItem = nextItem.nextElementSibling;
              continue;
            }

            const nextId = nextInput.value;
            const nextProduct = productInventoryMap.get(nextId);

            if (nextProduct?.available) {
              nextInput.setAttribute('data-product-checked', 'true');
              nextInput.checked = true;
              break;
            }

            nextItem = nextItem.nextElementSibling;
          }
        }
      });
    };


    initProducts();

    const addSortProducts = () => {
      const activeStartsetOptions = document.querySelectorAll('.voo-sort-product-item');
      activeStartsetOptions.forEach((option) => {
        const productIdInput = option.querySelector('.voo-sort-radio');
    
        if (productIdInput && productIdInput.checked) {
          const productId = productIdInput.value;
    
          vooSelectedProducts.push({
            id: productId,
            properties: {
              _startset: 'startset',
            },
            quantity: 1,
          });
        }
      });
    }
    
    const addToGiftProducts = () => {
      const freeBlocks = document.querySelectorAll(
        '.voo-free-block__item input[type="text"]'
      );
    
      freeBlocks.forEach((block) => {
        const valueId = block.value;
        vooSelectedProducts.push({
          id: valueId,
          properties: {
            _startset: 'startset',
          },
          quantity: 1,
        });
      });
    }


    vooMainProduct.addEventListener('click', (event) => {
      if (event.target.id == 'startset-button__checkout--sort') {
        event.preventDefault();
        const sortProductContent = document.querySelectorAll('.voo-sort-block');

        addSortProducts();
        addToGiftProducts();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: vooSelectedProducts,
          }),
        })
          .then(function (response) {
            if (response.ok) {
              window.location.href = '/checkout';
            } else {
              console.error('Error adding an item to the cart:', response.statusText);
            }
          })
          .catch(function (error) {
            console.error('Error adding an item to the cart:', error);
          });
      }

      if (event.target.closest('.voo-sort-product-item')) {
        const previousProductInput = event.target.closest('.voo-sort-products').querySelector('.voo-sort-radio[data-product-checked]');
        const previousProductId = previousProductInput.value;
        previousProductInput.removeAttribute('data-product-checked');

        const productInput = event.target.closest('.voo-sort-product-item').querySelector('.voo-sort-radio');
        const productId = productInput.value;
        productInput.setAttribute('data-product-checked', 'true');

        productInventoryMap.forEach((value, key) => {
          if (previousProductId === key) {
            value.quantity = value.quantity + 1;

            if (!value.available) {
              value.available = true;

              const previousSelectedInputEntities = document.querySelectorAll(`input[value="${previousProductId}"]`);
              previousSelectedInputEntities.forEach((radio) => {
                const parentItem = radio.closest('.voo-sort-product-item');
                if (parentItem) {
                  parentItem.classList.remove('voo-sort-product-item--disabled');
                }
              });
            }
          }

          if (key === productId && value.available) {

            value.quantity = value.quantity -1;
            if (value.quantity <= 0) {
              value.available = false;
            }

            const availableToCheckInputs = document.querySelectorAll('.voo-sort-product-item:not(.voo-sort-product-item--disabled) .voo-sort-radio:not(:checked):not([data-product-checked])');
            availableToCheckInputs.forEach((radio) => {
              if (radio.value === productId && !value.available) {
                const parentItem = radio.closest('.voo-sort-product-item');
                if (parentItem) {
                  parentItem.classList.add('voo-sort-product-item--disabled');
                }
              }
            });
          }
        });
      }
    });
  }
})();

const mainContentProduct = document.getElementById('MainContent');

if (mainContentProduct) {
  mainContentProduct.addEventListener('click', (event) => {
    const vooProductOptionItem = event.target.classList.contains('voo-product-option__item');
    const dataHandle = event.target.getAttribute('data-handle');
    const vooMainProduct = document.querySelector('.voo-main-product');

    if (vooProductOptionItem) {
      event.preventDefault();
      fetch(dataHandle)
        .then((response) => response.text())
        .then((data) => {
          const domParser = new DOMParser();
          const htmlMarkup = domParser.parseFromString(data, 'text/html');
          const markupVooMainProduct = htmlMarkup.querySelector('.voo-main-product');

          if (markupVooMainProduct && vooMainProduct) {
            vooMainProduct.innerHTML = markupVooMainProduct.innerHTML;
          }

          window.history.replaceState({}, '', dataHandle);
        })
        .catch((error) => {
          console.error('Fetch error:', error);
        });
    }
  });
}
